import React from 'react';

function OrderListItem({ order, onDriverAction, getOrderStatusColor, formatCurrency }) {
  return (
    <div
      className={`order-item ${order.is_available ? 'order-available' : ''}`}
    >
      {order.is_available && (
        <div style={{
          background: 'linear-gradient(135deg, #22C55E 0%, #15803D 100%)',
          color: 'white',
          padding: '8px 12px',
          borderRadius: '8px 8px 0 0',
          fontSize: '12px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          🎯 Pedido Disponible
        </div>
      )}
      <div className="order-item-header" style={{ padding: order.is_available ? '12px 12px 0 12px' : '12px' }}>
        <span className="order-item-code">#{order.order_code}</span>
        <span
          className="order-item-status"
          style={{ backgroundColor: getOrderStatusColor(order.status) }}
        >
          {order.status}
        </span>
      </div>
      <div style={{ padding: '0 12px 12px 12px' }}>
        {order.distance_to_restaurant_km && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '8px',
            padding: '6px 10px',
            background: '#F7F7F7',
            borderRadius: '6px',
            fontSize: '13px'
          }}>
            <span>🏪</span>
            <span style={{ color: '#8E8E93' }}>A {order.distance_to_restaurant_km} km del restaurante</span>
          </div>
        )}
        <p className="order-item-address">📍 {order.delivery_address}</p>
        {order.total_cents && (
          <p className="order-item-total">{formatCurrency(order.total_cents)}</p>
        )}
        {order.is_available && (
          <button
            onClick={() => onDriverAction('accepted', order.id)}
            className="action-btn accept-btn"
            style={{
              width: '100%',
              marginTop: '10px',
              fontSize: '14px',
              padding: '10px'
            }}
          >
            ✅ Aceptar Pedido
          </button>
        )}
      </div>
    </div>
  );
}

export default OrderListItem;
